import { render, staticRenderFns } from "./ReleaseViewDiloag.vue?vue&type=template&id=a69de7c2"
import script from "./ReleaseViewDiloag.vue?vue&type=script&lang=js"
export * from "./ReleaseViewDiloag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports